export default __webpack_public_path__ + "static/media/hingo-screenshot-03.61983d62.png";